import { render, staticRenderFns } from "./category-modal.vue?vue&type=template&id=6f817c37&"
import script from "./category-modal.vue?vue&type=script&lang=js&"
export * from "./category-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports